"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useScrollPosition", {
  enumerable: true,
  get: function get() {
    return _useScrollPosition.useScrollPosition;
  }
});

var _useScrollPosition = require("./useScrollPosition");